module.exports = __webpack_public_path__ + "img/DSC_1080.3e990d57.jpg";